import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_vr7t7e7cnz: FaireCollectionEntity = {
  token: "pbc_vr7t7e7cnz",
  type: "collection",
  name: "Back To School ✏️🍎",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d83cd4e4ceffe7d6a2a71455b6ff1fea5c8cd503f6b10e1877b163f9aed1e8fa.jpeg",
  itemCount: 44,
  description:
    "Get an A+ in style with our new grade tees, tutus and matching bows!",
  brandToken: "b_gro99lye",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-12T06:26:38.335Z",
    importedBy: "entity-db-import-collections",
  },
};
